import { FunctionComponent } from "react";
import { Collapse as AntCollapse } from "antd";
import { ConfigProvider } from "@ui-kit/ConfigProvider/ConfigProvider";
import "./Collapse.css";
const CollapseNumberedHeader: FunctionComponent<{
  label: string;
  index: number;
}> = ({ label, index }) => {
  return (
    <div
      className="collapse-numbered-header"
      data-testid="collapse-numbered-header">
      <div className="collapse-numbered-header-number">{index + 1}</div>
      <div className="collapse-numbered-header-label">{label}</div>
    </div>
  );
};

const CollapseNumberedHeaderStyles = (index: number) => ({
  header:
    index === 0
      ? { padding: "0px 0px 24px 0px" }
      : {
          padding: "24px 0px",
          borderTop: "1px solid var(--border-primary)",
        },
  body: {
    padding: "0px 0px 20px 0px",
  },
});

type CollapseProps = React.ComponentProps<typeof AntCollapse>;

const Collapse: FunctionComponent<CollapseProps> = ({
  items,
  defaultActiveKey,
  onChange,
  ghost,
  bordered,
  expandIconPosition,
  ...rest
}) => {
  return (
    <ConfigProvider>
      <AntCollapse
        defaultActiveKey={defaultActiveKey}
        onChange={onChange}
        items={items}
        ghost={ghost}
        bordered={bordered}
        expandIconPosition={expandIconPosition}
        {...rest}
      />
    </ConfigProvider>
  );
};

export { Collapse, CollapseNumberedHeader, CollapseNumberedHeaderStyles };
